import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../components/Header'
import { SearchField } from '../../../../components/SearchField'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { useConfigContext } from '../../../ui-config'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
}

export const Title: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
}) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  const actions = (
    <SearchField
      searchValue={globalFilterValue}
      setSearchValue={setGlobalFilterValue}
      placeholder={t('orders.title.search.placeholder', {
        field: getConfigTranslation(
          config.orderResponse.orderInformation.orderId.label,
        ),
      })}
    />
  )

  return <Header title={t('orders.title.title')} actions={actions} />
}
